export default __webpack_public_path__ + "static/media/brand11.7f52fa75.svg";